import {css} from 'styled-components';

export default css`
  .field-container {
    margin-top: 10px;
  }
`;
